import SelectLoanType from './SelectLoanType';

export default SelectLoanType;